import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export const useSettings = () => useContext(SettingsContext) || {};

export const SettingsProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [social, setSocial] = useState({});
  const [stats, setStats] = useState({ views: 0, follows: 0 });
  const [followed, setFollowed] = useState(
    () => typeof window !== "undefined" && localStorage.getItem("mk_followed") === "1"
  );

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => {
        setContent(r.data.content);
        setSocial(r.data.social);
        setStats(r.data.stats);
      })
      .catch(() => {});

    if (!sessionStorage.getItem("mk_viewed")) {
      sessionStorage.setItem("mk_viewed", "1");
      api
        .post("/stats/view")
        .then((r) => setStats((s) => ({ ...s, ...r.data })))
        .catch(() => {});
    }
  }, []);

  // Inject social profiles into structured data (sameAs) for SEO/branding
  useEffect(() => {
    const urls = Object.values(social || {}).filter(Boolean);
    if (!urls.length) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-social-ld", "1");
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Charles McKuhn",
      alternateName: "Charles A. McKuhn Jr.",
      sameAs: urls,
    });
    document.head.appendChild(el);
    return () => el.remove();
  }, [social]);

  const doFollow = useCallback(async () => {
    if (localStorage.getItem("mk_followed") === "1") return { already: true };
    const { data } = await api.post("/follow", {});
    localStorage.setItem("mk_followed", "1");
    setFollowed(true);
    setStats((s) => ({ ...s, ...data }));
    return { already: false };
  }, []);

  return (
    <SettingsContext.Provider value={{ content, social, stats, followed, doFollow }}>
      {children}
    </SettingsContext.Provider>
  );
};
